var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Comment } from './comment';
import { useMutation, gql, useApolloClient } from '@apollo/client';
import { Element, animateScroll as scroll } from 'react-scroll';
import { Dialog } from '../elements/dialog';
import { sprintf } from 'sprintf-js';
import { Loader } from '../elements/loader';
import { IconButton } from '../elements/icon-button';
import { TickIcon } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { EntityCommentInput } from './entity-comment-input';
import { useActivePerson } from '../hooks/use-active-person';
import { useAuth } from '../hooks/use-auth';
import { useEntityTypeDefinitionQuery } from '../hooks/use-entity-type-definition-query';
import { entityTypeNameFor } from '@shapeable/utils';
import { useModal } from '../hooks/use-modal';
import { useRefetch } from '../hooks/use-refetch';
import { AppDialog } from '../app/app-dialog';
// import { currentUserCanCreate, personCanAdmin, personCanCreate } from '../../utils/current-user-can';
// import { useAppLayout } from '../../hooks/use-app-layout';
// import { useActivePerson } from '../../hooks/use-active-person';
// import { useEntities } from '../../hooks/use-entities';
// import { useModal } from '../../hooks/use-modal';
// import { useDimensions } from '../../hooks/use-dimensions';
export var CREATE_COMMENT_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateCommentMutation($input: CommentInput!) {\n    createComment(input: $input) {\n      id\n      created\n      __typename\n      description {\n        id text\n      }\n      createdBy {\n        id __typename\n        name\n        organisation {\n          id\n          name\n        }\n        photo {\n         id url\n        }\n      }\n      parent {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id\n          name\n        }\n      }\n      replies {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id __typename\n          name\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateCommentMutation($input: CommentInput!) {\n    createComment(input: $input) {\n      id\n      created\n      __typename\n      description {\n        id text\n      }\n      createdBy {\n        id __typename\n        name\n        organisation {\n          id\n          name\n        }\n        photo {\n         id url\n        }\n      }\n      parent {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id\n          name\n        }\n      }\n      replies {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id __typename\n          name\n        }\n      }\n    }\n  }\n"])));
var UPDATE_COMMENT_MUTATION = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation UpdateCommentMutation($id: ID!, $input: CommentInput!) {\n    updateComment(id: $id, input: $input) {\n      id\n      created\n      __typename\n      description {\n        id text\n      }\n      createdBy {\n        id __typename\n        name\n        position\n        organisation {\n          id\n          name\n        }\n        photo {\n         id url\n        }\n      }\n      parent {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id\n          name\n        }\n      }\n      replies {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id\n          __typename\n          name\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateCommentMutation($id: ID!, $input: CommentInput!) {\n    updateComment(id: $id, input: $input) {\n      id\n      created\n      __typename\n      description {\n        id text\n      }\n      createdBy {\n        id __typename\n        name\n        position\n        organisation {\n          id\n          name\n        }\n        photo {\n         id url\n        }\n      }\n      parent {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id\n          name\n        }\n      }\n      replies {\n        id __typename\n        description {\n          id text\n        }\n        createdBy {\n          id\n          __typename\n          name\n        }\n      }\n    }\n  }\n"])));
var DELETE_COMMENT_MUTATION = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation DeleteCommentMutation($id: ID!) {\n    deleteComment(id: $id)\n  }\n"], ["\n  mutation DeleteCommentMutation($id: ID!) {\n    deleteComment(id: $id)\n  }\n"])));
export var EntityConversationDefaultProps = {
  anchorName: "conversation-body",
  stretch: false,
  showHeader: true,
  showInputs: true,
  showCreator: false,
  title: 'Conversation',
  setComments: function () {},
  isLoading: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 100%; \n    display: flex;\n    flex-direction: column;\n    overflow: hidden; \n    font-size: ", ";\n  "], ["\n    height: 100%; \n    display: flex;\n    flex-direction: column;\n    overflow: hidden; \n    font-size: ", ";\n  "])), theme.FONT_SIZE(14))
});
var FixedInputStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-shrink: 0;\n  \n  "], ["\n    flex-shrink: 0;\n  \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex: 1;\n    overflow-y: auto;\n  "], ["\n    flex: 1;\n    overflow-y: auto;\n  "])))
});
var CommentsStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n\n    > li:first-child {\n      border-top: none;\n    }\n  "], ["\n    margin: 0;\n    padding: 0;\n\n    > li:first-child {\n      border-top: none;\n    }\n  "])))
});
var CommentItemStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", " 0 ", " 0;\n    margin: 0;\n    list-style: none;\n  "], ["\n    padding: ", " 0 ", " 0;\n    margin: 0;\n    list-style: none;\n  "])), theme.UNIT(3), theme.UNIT(1)),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: ", " 0 ", " 0;\n  "], ["\n    padding: ", " 0 ", " 0;\n  "])), theme.UNIT(4), theme.UNIT(1))
});
var REPLY_INDENT_UNITS = 13;
var RepliesStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    background: none;\n    margin-left: ", ";\n    margin-top: ", ";\n  "], ["\n    ", ";\n    background: none;\n    margin-left: ", ";\n    margin-top: ", ";\n  "])), CommentsStyles, theme.UNIT(REPLY_INDENT_UNITS), theme.UNIT(1))
});
var ReplyItemStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n  "], ["\n    ", ";\n    padding-top: ", ";\n  "])), CommentItemStyles, theme.UNIT(2)),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme.UNIT(4))
});
var CommentStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ReplyStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CommentInputStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n   flex-shrink: 0; // Prevent it from shrinking\n   position: relative;\n   \n  "], ["\n   flex-shrink: 0; // Prevent it from shrinking\n   position: relative;\n   \n  "]))),
  tablet: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CommentEditInputStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ReplyInputStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    margin-left: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-left: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n  "])), theme.UNIT(REPLY_INDENT_UNITS), theme.UNIT(3), theme.UNIT(6)),
  tablet: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme.UNIT(4))
});
var ReplyEditInputStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DeleteDialogStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DeleteDialogBodyStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n  "])), theme.UNIT(2))
});
var DeleteConfirmButtonStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    align-self: center;\n  "], ["\n    align-self: center;\n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EmptyLayoutStyles = breakpoints({
  base: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    height: 100%;\n    display: flex;\n    padding: ", ";\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n    font-size: 1.3em;\n    font-weight: 500;\n    color: ", ";\n  "], ["\n    height: 100%;\n    display: flex;\n    padding: ", ";\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n    font-size: 1.3em;\n    font-weight: 500;\n    color: ", ";\n  "])), theme.UNIT(4), theme.COLOR('text'))
});
var FooterStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    position: fixed;\n    bottom: 0;\n    box-sizing: border-box;\n    background: ", ";\n    z-index: 100;\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n\n    ", "\n  "], ["\n    position: fixed;\n    bottom: 0;\n    box-sizing: border-box;\n    background: ", ";\n    z-index: 100;\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n\n    ", "\n  "])), theme.COLOR('app-chrome'), theme.COLOR('line-subtle'), theme.UNIT(3), theme.UNIT(4), theme.UNIT(4), function (_a) {
    var _width = _a._width;
    return css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), _width);
  })
});
var FooterCommentInputStyles = breakpoints({
  base: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled(Element)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Comments: styled.ul(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), CommentsStyles),
  CommentItem: styled.li(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), CommentItemStyles),
  Comment: styled(Comment)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), CommentStyles),
  CommentInput: styled(EntityCommentInput)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), CommentInputStyles),
  CommentEditInput: styled(EntityCommentInput)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), CommentEditInputStyles),
  FooterCommentInput: styled(EntityCommentInput)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), FooterCommentInputStyles),
  Replies: styled.ul(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), RepliesStyles),
  ReplyItem: styled.li(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ReplyItemStyles),
  Reply: styled(Comment)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ReplyStyles),
  ReplyInput: styled(EntityCommentInput)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), ReplyInputStyles),
  ReplyEditInput: styled(EntityCommentInput)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), ReplyEditInputStyles),
  DeleteDialog: styled(Dialog)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), DeleteDialogStyles),
  DelteDialogBody: styled.div(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), DeleteDialogBodyStyles),
  DeleteAppDialog: styled(AppDialog)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), DeleteDialogStyles),
  DeleteConfirmButton: styled(IconButton)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), DeleteConfirmButtonStyles),
  Loader: styled(Loader)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  FixedInput: styled.div(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), FixedInputStyles),
  EmptyLayout: styled.div(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), EmptyLayoutStyles),
  Footer: styled.div(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
export var EntityConversation = function (props) {
  var className = props.className,
    onSubmit = props.onSubmit,
    anchorName = props.anchorName,
    setComments = props.setComments,
    stretch = props.stretch,
    showInputs = props.showInputs,
    showNewCommentInFooter = props.showNewCommentInFooter,
    entity = props.entity,
    isLoading = props.isLoading;
  var comments = props.comments;
  var t = useLang();
  var person = useActivePerson().person;
  var scrollableAreaRef = useRef(null);
  useEffect(function () {
    scroll.scrollToBottom({
      containerId: anchorName,
      duration: 300,
      smooth: true
    });
  }, [comments]);
  var refetch = useRefetch();
  var modal = useModal();
  var loggedInUser = useAuth();
  var _a = __read(useState(), 2),
    editingComment = _a[0],
    setEditingComment = _a[1];
  var _b = __read(useState(false), 2),
    deleting = _b[0],
    setDeleting = _b[1];
  var _c = __read(useState(false), 2),
    submitting = _c[0],
    setSubmitting = _c[1];
  var _d = __read(useState(null), 2),
    submittingReplyFor = _d[0],
    setSubmittingReplyFor = _d[1];
  var _e = __read(useState(null), 2),
    submittingUpdateFor = _e[0],
    setSubmittingUpdateFor = _e[1];
  var entityTypeName = entityTypeNameFor(entity);
  var entityTypeDefinition = useEntityTypeDefinitionQuery(entityTypeName).entityTypeDefinition;
  var _f = __read(useMutation(CREATE_COMMENT_MUTATION), 2),
    createComment = _f[0],
    createError = _f[1].error;
  var _g = __read(useMutation(UPDATE_COMMENT_MUTATION), 2),
    updateComment = _g[0],
    updateError = _g[1].error;
  var _h = __read(useMutation(DELETE_COMMENT_MUTATION), 2),
    deleteComment = _h[0],
    deleteError = _h[1].error;
  var hasComments = !!comments.length;
  var handleCancel = function () {
    setEditingComment(null);
  };
  var modalLabel = function (isReply) {
    return isReply ? t('Reply') : t('Comment');
  };
  var modalTitle = function (isReply) {
    var label = modalLabel(isReply);
    return sprintf(t('Delete %s'), label);
  };
  var onDelete = function (id, isReply) {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setDeleting(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            modal.show(React.createElement(My.DeleteDialog, {
              title: modalTitle(isReply),
              isCancelButtonDisabled: true
            }, React.createElement(My.Loader, {
              spinnerSize: 18
            })));
            return [4 /*yield*/, deleteComment({
              variables: {
                id: id
              },
              update: function (cache) {
                cache.evict({
                  id: cache.identify({
                    __typename: "Comment",
                    id: id
                  })
                });
                cache.gc();
              }
            }).catch(function (error) {
              console.error('Mutation error:', error);
            })];
          case 2:
            _a.sent();
            modal.hide();
            return [3 /*break*/, 5];
          case 3:
            error_1 = _a.sent();
            console.error("Failed to delete comment:", error_1);
            modal.hide();
            return [3 /*break*/, 5];
          case 4:
            setDeleting(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  var confirmDelete = function (id, isReply) {
    var label = modalLabel(isReply);
    modal.show(React.createElement(My.DeleteAppDialog, {
      action: 'delete',
      onCloseClick: function () {
        return modal.hide();
      },
      onButtonAction: function () {
        return onDelete(id, isReply);
      },
      startControls: !deleting && React.createElement(My.DeleteConfirmButton, {
        showChildren: true,
        iconSize: 20,
        icon: React.createElement(TickIcon, null),
        onClick: function () {
          return onDelete(id, isReply);
        }
      }, t('Confirm')),
      title: sprintf(t('%s'), label)
    }, React.createElement(My.DelteDialogBody, null, sprintf(t('Are you sure you want to delete this %s?'), label), React.createElement("br", null), React.createElement("br", null), React.createElement("b", null, t('This is not reversible.')))));
  };
  var client = useApolloClient();
  var handleSubmit = function (_a) {
    var parent = _a.parent,
      id = _a.id;
    return function (_a) {
      return __awaiter(void 0, [_a], void 0, function (_b) {
        var entityTypeName, definition, fieldName, metadata, input, error_2;
        var _c;
        var value = _b.value;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              entityTypeName = entity.__typename;
              definition = entityTypeDefinition;
              if (!definition) {
                throw new Error("Cannot find the entity type ".concat(entityTypeName, " to attach this comment to."));
              }
              fieldName = definition.oneName;
              metadata = {
                parent: {
                  name: entity.name,
                  id: entity.id,
                  type: entityTypeName
                }
              };
              input = (_c = {
                metadata: metadata,
                parent: parent
              }, _c[fieldName] = entity.id, _c.description = value, _c);
              _d.label = 1;
            case 1:
              _d.trys.push([1, 6,, 7]);
              if (!id) return [3 /*break*/, 3];
              // Update existing comment
              setSubmittingUpdateFor(id);
              return [4 /*yield*/, updateComment({
                variables: {
                  id: id,
                  input: input
                }
              })];
            case 2:
              _d.sent();
              setSubmittingUpdateFor(null);
              setEditingComment(null);
              return [3 /*break*/, 5];
            case 3:
              parent ? setSubmittingReplyFor(parent) : setSubmitting(true);
              return [4 /*yield*/, createComment({
                variables: {
                  input: input
                }
              })];
            case 4:
              _d.sent();
              refetch();
              setSubmitting(false);
              setSubmittingReplyFor(null);
              _d.label = 5;
            case 5:
              if (onSubmit) {
                onSubmit({
                  value: value,
                  parent: parent
                });
              }
              return [3 /*break*/, 7];
            case 6:
              error_2 = _d.sent();
              console.error("Failed to ".concat(id ? "update" : "create", " comment:"), error_2);
              return [3 /*break*/, 7];
            case 7:
              return [2 /*return*/];
          }
        });
      });
    };
  };
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Body, {
    ref: scrollableAreaRef,
    id: anchorName,
    name: anchorName,
    _height: stretch ? 30 : 0
  }, hasComments && React.createElement(My.Comments, null, comments.filter(function (comment) {
    return !comment.parent;
  }).map(function (comment) {
    return React.createElement(My.CommentItem, {
      key: "comment-".concat(comment.id)
    }, editingComment === comment.id ? React.createElement(My.CommentEditInput, {
      autoFocus: true,
      creator: comment.createdBy,
      isEdit: true,
      initialValue: comment.description && comment.description.text,
      isSubmitting: comment.id === submittingUpdateFor,
      onCancel: handleCancel,
      onSubmit: handleSubmit({
        id: comment.id
      })
    }) : React.createElement(My.Comment, {
      showEditControls: showInputs,
      canEdit: person && comment.createdBy.id === person.id,
      canDelete: !comment.replies.length,
      onDelete: function () {
        return confirmDelete(comment.id);
      },
      entity: comment,
      onEdit: function () {
        return setEditingComment(comment.id);
      }
    }), React.createElement(React.Fragment, null, comment.replies && !!comment.replies.length && React.createElement(My.Replies, null, comment.replies.map(function (reply) {
      return React.createElement(My.ReplyItem, {
        key: "reply-".concat(reply.id)
      }, editingComment === reply.id ? React.createElement(My.ReplyEditInput, {
        creator: reply.createdBy,
        autoFocus: true,
        isEdit: true,
        initialValue: reply.description && reply.description.text,
        isSubmitting: reply.id === submittingUpdateFor,
        onCancel: handleCancel,
        onSubmit: handleSubmit({
          id: reply.id,
          parent: comment.id
        }),
        isReply: true
      }) : React.createElement(My.Reply, {
        showEditControls: showInputs,
        canDelete: true,
        canEdit: person && reply.createdBy.id === person.id,
        onDelete: function () {
          return confirmDelete(reply.id, true);
        },
        isReply: true,
        entity: reply,
        onEdit: function () {
          return setEditingComment(reply.id);
        }
      }));
    })), React.createElement(My.ReplyInput, {
      key: "reply-input-".concat(comment.id, "-").concat(comment.replies.length),
      disabled: !!editingComment,
      isSubmitting: comment.id === submittingReplyFor,
      onSubmit: handleSubmit({
        parent: comment.id
      }),
      isReply: true
    })));
  }))), React.createElement(My.FixedInput, null, React.createElement(My.CommentInput, {
    key: "comment-input-".concat(comments.length),
    isMainInput: true,
    disabled: !!editingComment,
    isSubmitting: submitting,
    onSubmit: handleSubmit({})
  })));
};
EntityConversation.defaultProps = EntityConversationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49;